import { apiHelper, sharedHelper, sessionHelper } from '@/utils'
import { API } from '@/constants'

export const serviceService = {
    getAllServices,
    getService,
    updateService,
    createService,
    updateServiceStatus,
};

const MODULE = {
    SERVICE: 'menu-services',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllServices(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    if (sessionHelper.getUserType == "STAFF") {
        requestOptions.params['company'] = sessionHelper.getStaffCompanyUUID()
    }

    return apiHelper(API_URL).get(`/${MODULE.SERVICE}`, requestOptions)
}

export function getService(id) {
    return apiHelper(API_URL).get(`/${MODULE.SERVICE}/${id}`)
}

export function updateService(data) {

    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'menu_uuid', data.menuID);
    sharedHelper.appendIfNotNull(formData, 'service_type_uuid', data.serviceTypeID);
    sharedHelper.appendIfNotNull(formData, 'description', data.description);
    sharedHelper.appendIfNotNull(formData, 'after_service_description', data.afterServiceDescription);
    sharedHelper.appendIfNotNull(formData, 'price', data.price);
    sharedHelper.appendIfNotNull(formData, 'price_type_id', data.priceTypeID);
    sharedHelper.appendIfNotNull(formData, 'rebook_day_after_service', data.rebookDayAfterService);
    sharedHelper.appendIfNotNull(formData, 'duration_minutes', data.durationMinutes);
    formData.append('_method', 'PUT');

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.name);
    });

    if (data.isRebookNeeded != "" && data.isRebookNeeded == true) {
        formData.append('is_rebook_needed', 1);
    }
    else {
        formData.append('is_rebook_needed', 0);
    }

    if (data.image instanceof File) {
        formData.append('image', data.image);
    }

    return apiHelper(API_URL).post(`/${MODULE.SERVICE}/${data.id}`, formData)
}

export function createService(data) {
    const formData = new FormData();

    data.forEach((service, index) => {

        formData.append(`service[${index}][menu_uuid]`, service.menuID.value);
        formData.append(`service[${index}][service_type_uuid]`, service.serviceTypeID.value);
        formData.append(`service[${index}][description]`, service.description);
        formData.append(`service[${index}][after_service_description]`, service.afterServiceDescription);
        formData.append(`service[${index}][price]`, service.price);
        formData.append(`service[${index}][price_type_id]`, service.priceTypeID);
        formData.append(`service[${index}][rebook_day_after_service]`, service.rebookDayAfterService);
        formData.append(`service[${index}][duration_minutes]`, service.durationMinutes);

        if (service.isRebookNeeded != null && service.isRebookNeeded == true) {
            formData.append(`service[${index}][is_rebook_needed]`, 1);
        }
        else {
            formData.append(`service[${index}][is_rebook_needed]`, 0);
        }

        if (service.image instanceof File) {
            formData.append(`service[${index}][image]`, service.image);
        }

        service.names.forEach((name, index) => {
            formData.append(`service[${index}][name][${index}][language_code]`, name.language.code);
            formData.append(`service[${index}][name][${index}][value]`, name.name);
        });

    });

    return apiHelper(API_URL).post(`/${MODULE.SERVICE}`, formData)
}

export function updateServiceStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.SERVICE}/${data.id}`, requestOptions)
}